<script setup>
import { ref } from 'vue'
import { useDisplay } from 'vuetify'

const nuxtApp = useNuxtApp()
const { smAndDown } = useDisplay()
const isLoaded = ref(false)
const isPlaying = ref(false)
const video = ref()

const props = defineProps({
    id: {
        type: String,
        default: null,
    },
    handle: {
        type: String,
        default: null,
    },
})

const { data, status, error } = await useLazyAsyncData(
    `${props.handle}-videos`,
    () => $fetch(`/api/product/query?id=${props.id}&what=videos`),
    {
        transform: (data) => {
            return {
                videos: data.product.productVideos.edges.map((edge) => edge.node),
                fetchedAt: new Date(Date.now()),
            }
        },
        getCachedData(key) {
            const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key]

            if (!data) {
                return
            }

            const expirationDate = new Date(data.fetchedAt)
            expirationDate.setTime(expirationDate.getTime() + 60 * 60000) // cache set to 1 hour
            const isExpired = expirationDate.getTime() < Date.now()
            if (isExpired) {
                return
            }

            return data
        },
    }
)

watchEffect(() => {
    if (error.value) {
        throw createError({
            statusCode: 500,
            message: error.value,
            fatal: false,
        })
    }
})

async function play() {
    await video.value.player.playVideo()
}

function stateChange(event) {
    isPlaying.value = event.data === 1
}
</script>

<template>
    <v-row id="productvideos" class="justify-center">
        <v-col v-if="status === 'pending' || status === 'idle'" cols="12"><app-loader /></v-col>
        <v-col v-else cols="10" class="my-16 rounded">
            <v-row class="justify-center">
                <!-- <v-col cols="12" class="mb-4 text-center">
                    <app-section-header :id="`video`" :title="`Video`" :subtitle="`Videos`" />
                </v-col> -->
                <v-col
                    v-for="video in data.videos"
                    :key="video.id"
                    cols="12"
                    sm="6"
                    class="d-flex flex-column align-center"
                >
                    <ScriptYouTubePlayer
                        :video-id="video.source"
                        @ready="isLoaded = true"
                        @state-change="stateChange"
                        class="rounded"
                    >
                        <template #awaitingLoad>
                            <div class="d-flex align-center wrapper">
                                <svg height="16%" version="1.1" viewBox="0 0 68 48" width="100%">
                                    <path
                                        d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"
                                        fill="#f00"
                                    />
                                    <path d="M 45,24 27,14 27,34" fill="#fff" />
                                </svg>
                            </div>
                        </template>
                    </ScriptYouTubePlayer>
                    <div class="mt-2 text-center st-subheader">{{ video.title }}</div>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped>
.wrapper {
    position: absolute;
    top: 0;
    width: 100%;
    height: -webkit-fill-available;
}
</style>
